import Vue from "vue";
import vueHljs from "vue-hljs";
import './styles.scss';

Vue.use(vueHljs);